'use client';
import { useLenis } from 'lenis/react';
import { usePathname } from 'next/navigation';
import React, { useLayoutEffect } from 'react';

export const ScrollToTop = () => {
  const lenis = useLenis();
  const pathname = usePathname();

  useLayoutEffect(() => {
    if (typeof window === 'undefined') return;

    // Prevent browser's default scroll restoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    if (lenis) {
      lenis.scrollTo(0, { immediate: true, force: true });
    }
  }, [lenis, pathname]); // <-- add pathname as a dependency

  return null;
};
